import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MonitoringRoutingModule} from './monitoring-routing.module';
import {MotiveOccurrenceComponent} from './motive-occurrence/motive-occurrence.component';
import {OccurrenceComponent} from './occurrence/occurrence.component';
import {NewOccurrenceComponent} from './new-occurrence/new-occurrence.component';
import {SharedModule} from "../../shared/shared.module";

import {MultiSelectModule} from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip'
import {ToastModule} from 'primeng/toast';
import {InputTextModule} from 'primeng/inputtext';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {CardModule} from "primeng/card";
import {FieldsetModule} from "primeng/fieldset";
import {MessageService} from 'primeng/api';
import {DropdownModule} from 'primeng/dropdown';
import {ToolbarModule} from 'primeng/toolbar';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { BreadcrumbModule } from "primeng/breadcrumb";
import { FileUploadModule } from 'primeng/fileupload';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import {TagModule} from 'primeng/tag'
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {InputSwitchModule} from 'primeng/inputswitch';
// import { InputTextareaModule } from "primeng/inputtextarea";
import { SkeletonModule } from 'primeng/skeleton';
import { InputTextareaModule } from "primeng/inputtextarea";
import { EquipmentVideoComponent } from './equipment-video/equipment-video.component';
import {EquipmentOperationStartComponent} from './equipment-operation-start/equipment-operation-start.component';
import {TimeMaskDirective} from './directives/time-mask-directive';
import { MultiSelect } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';


@NgModule({
  declarations: [
    MotiveOccurrenceComponent,
    OccurrenceComponent,
    NewOccurrenceComponent,
    EquipmentVideoComponent,
    EquipmentOperationStartComponent,
    TimeMaskDirective
  ],
  imports: [
    CommonModule,
    MultiSelectModule,
    SharedModule,
    MonitoringRoutingModule,
    InputTextModule,
    ButtonModule,
    ToastModule,
    DialogModule,
    FormsModule,
    TableModule,
    CardModule,
    FieldsetModule,
    DropdownModule,
    ToolbarModule,
    CalendarModule,
    CheckboxModule,
    ConfirmDialogModule,
    BreadcrumbModule,
    TooltipModule,
    FileUploadModule,
    TagModule,
    DividerModule,
    ProgressSpinnerModule,
    TabMenuModule,
    MultiSelectModule,
    InputSwitchModule,
    InputTextareaModule,
    SkeletonModule,
    TabViewModule,
    InputNumberModule,
],
  providers: [
    MessageService
  ]
})

export class MonitoringModule{ }
